<template>
    <v-container fill-height fluid grid-list-xl class="pa-3">
        <v-layout wrap>
            <v-flex xs12>
                <v-card class="pa-3">
                    <v-card-title class="headline pl-0 pt-0"
                        >Menu Items</v-card-title
                    >
                    <v-layout row class="">
                        <v-btn
                            small
                            style="height: 28px;"
                            color="success"
                            class="mb-2 ml-3"
                            @click="addItem"
                            v-if="!newItems.length"
                            >Add Item</v-btn
                        >
                        <v-btn
                            v-if="menuItems.some((i) => i.selected)"
                            class="mb-3 ml-2"
                            small
                            style="height: 28px;"
                            color="warning"
                            @click="deleteItems"
                            >Delete Items</v-btn
                        >
                        <v-spacer></v-spacer>
                        <download-excel
                            :fields="exportFields()"
                            :name="getExportFileName()"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportToExcel"
                            type="xls"
                        >
                            <v-btn
                                color="success"
                                small
                                :loading="isExporting"
                                class="mb-3 mr-3"
                                ><v-icon>mdi-file-export</v-icon>export</v-btn
                            >
                        </download-excel>
                    </v-layout>
                    <div v-for="(newItem, index) in newItems">
                        <v-layout column class="pa-0 ml-3 mb-0">
                            <v-layout row>
                                <v-text-field
                                    class="width-250 mr-2"
                                    v-model="newItem.name"
                                    label="Name"
                                    :rules="[rules.required]"
                                    ref="newName"
                                ></v-text-field>
                                <v-text-field
                                    class="width-250 mx-2"
                                    v-model="newItem.itemDescription"
                                    label="Heb Name"
                                ></v-text-field>
                                <v-select
                                    class="width-150 mx-2"
                                    v-model="newItem.choiceType"
                                    label="Choice Type"
                                    :items="['INPUT', 'CHOOSE']"
                                    ref="choiceType"
                                ></v-select>
                            </v-layout>
                            <v-layout row>
                                <v-checkbox
                                    class="width-150 my-0 pt-3 mr-2"
                                    hide-details
                                    label="Allow Change"
                                    v-model="newItem.allowChange"
                                    color="success"
                                ></v-checkbox>
                                <v-text-field
                                    class="width-100 mx-2"
                                    v-model="newItem.standard"
                                    label="Standard"
                                    ref="standard"
                                ></v-text-field>
                                <v-text-field
                                    class="width-200 mx-2"
                                    v-model="newItem.distributionType"
                                    label="Distribution Type"
                                    :rules="[rules.required]"
                                    ref="newDistributionType"
                                ></v-text-field>
                                <v-text-field
                                    class="width-200 mx-2"
                                    v-model="newItem.maxInput"
                                    label="Max Input"
                                    type="number"
                                ></v-text-field>
                            </v-layout>
                            <v-layout row>
                                <v-select
                                    class="width-250 mx-2"
                                    v-model="newItem.distributionName"
                                    label="Distribution"
                                    :items="distributions.map((d) => d.week)"
                                ></v-select>
                                <v-text-field
                                    class="width-200 mx-2"
                                    v-model="newItem.sort"
                                    label="Sort Order"
                                    type="number"
                                ></v-text-field>
                                <v-text-field
                                    class="width-200 mx-2"
                                    v-model="newItem.labelSort"
                                    label="Label Sort"
                                    type="number"
                                ></v-text-field>
                            </v-layout>
                        </v-layout>
                        <div v-if="newItem.choiceType == 'CHOOSE'">
                            <v-btn
                                small
                                color="success"
                                class="ml-2 mt-0"
                                @click="addChoice(newItem)"
                                >Add Choice</v-btn
                            >
                            <v-layout
                                row
                                class="pa-0 ml-3 mb-0"
                                v-for="(choice, choiceIndex) in newItem.choices"
                            >
                                <v-text-field
                                    class="width-300 mr-2"
                                    v-model="choice.choice"
                                    label="Choice"
                                ></v-text-field>
                                <v-text-field
                                    class="width-100"
                                    v-model="choice.ivrInput"
                                    label="IVR Input"
                                    type="number"
                                    min="1"
                                ></v-text-field>
                                <v-btn
                                    @click="addChoice(newItem)"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    @click="removeChoice(newItem, choiceIndex)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                    </div>
                    <v-card-actions class="pt-0 ml-3" v-if="newItems.length">
                        <v-btn color="default" dark @click="cancelNewItems()"
                            >cancel
                        </v-btn>
                        <v-btn
                            color="success"
                            @click="saveMenuItem(newItems[0], true)"
                            >Save Item
                        </v-btn>
                    </v-card-actions>
                    <v-divider class="mb-4" v-if="newItems.length"></v-divider>
                    <v-layout row class="pa-0 ml-3 mb-0 font-weight-medium">
                        <div class="width-70 mr-1"></div>
                        <div class="width-250 pt-1">
                            Name
                        </div>
                        <div class="width-200 pt-1">
                            Description
                        </div>
                        <div class="width-120 pt-1">
                            Choice Type
                        </div>
                        <div class="width-150 pt-1">
                            Allow Change
                        </div>
                        <div class="width-100 pt-1">
                            Standard
                        </div>
                        <div class="width-150 pt-1">
                            Distribution Type
                        </div>
                        <div class="width-100 pt-1">
                            Max Input
                        </div>
                        <div class="width-100 pt-1">
                            Distribution
                        </div>
                        <div class="width-100 pt-1">
                            Sort
                        </div>
                        <div class="width-150 pt-1">
                            Label Sort
                        </div>
                        <div class="pt-1">
                            Choices
                        </div>
                    </v-layout>
                    <v-divider class="pb-0 pt-3"></v-divider>
                    <div
                        style="overflow-x: auto; height: 720px; overflow-y: auto;"
                        class="pb-2 pt-1"
                    >
                        <div v-for="(item, index) in menuItems">
                            <v-layout
                                row
                                class="pa-0 ml-3 mb-0"
                                v-if="!item.editing"
                            >
                                <v-layout row class="width-70 pt-3 mr-3">
                                    <v-checkbox
                                        class="my-0"
                                        hide-details
                                        v-model="item.selected"
                                        color="success"
                                    ></v-checkbox>
                                    <v-btn
                                        @click="editItem(item)"
                                        flat
                                        icon
                                        class="my-0 pb-2 pl-3 pr-4"
                                        color="success"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-layout>

                                <div class="width-250 pt-2">
                                    {{ item.name }}
                                </div>
                                <div class="width-200 pt-2">
                                    {{ item.itemDescription }}
                                </div>
                                <div class="width-120 pt-2">
                                    {{ item.choiceType }}
                                </div>
                                <div class="width-150 pt-2">
                                    {{ item.allowChange ? "Yes" : "No" }}
                                </div>
                                <div class="width-100 pt-2">
                                    {{ item.standard }}
                                </div>
                                <div class="width-150 pt-2">
                                    {{ item.distributionType }}
                                </div>
                                <div class="width-100 pt-2">
                                    {{ item.maxInput }}
                                </div>
                                <div class="width-100 pt-2">
                                    {{ item.distributionName }}
                                </div>
                                <div class="width-100 pt-2">
                                    {{ item.sort }}
                                </div>
                                <div class="width-150 pt-2">
                                    {{ item.labelSort }}
                                </div>
                                <div class="pt-2 width-150">
                                    {{ item.choicesDisplay }}
                                </div>
                            </v-layout>
                            <v-layout
                                column
                                class="pa-0 ml-3 mb-0 mt-3"
                                v-if="item.editing"
                            >
                                <v-layout row>
                                    <v-text-field
                                        class="width-250 mr-2"
                                        v-model="item.name"
                                        label="Name"
                                        :rules="[rules.required]"
                                        ref="name"
                                    ></v-text-field>
                                    <v-text-field
                                        class="width-250 mx-2"
                                        v-model="item.itemDescription"
                                        label="Heb Name"
                                    ></v-text-field>
                                    <v-select
                                        class="width-150 mx-2"
                                        v-model="item.choiceType"
                                        label="Choice Type"
                                        :items="['INPUT', 'CHOOSE']"
                                        ref="choiceType"
                                    ></v-select>
                                </v-layout>
                                <v-layout row>
                                    <v-checkbox
                                        class="width-150 my-0 pt-3 mr-2"
                                        hide-details
                                        label="Allow Change"
                                        v-model="item.allowChange"
                                        color="success"
                                    ></v-checkbox>
                                    <v-text-field
                                        class="width-100 mx-2"
                                        v-model="item.standard"
                                        label="Standard"
                                        ref="standard"
                                    ></v-text-field>
                                    <v-text-field
                                        class="width-200 mr-2"
                                        v-model="item.distributionType"
                                        label="Distribution Type"
                                        :rules="[rules.required]"
                                        ref="distributionType"
                                    ></v-text-field>
                                    <v-text-field
                                        class="width-200 mx-2"
                                        v-model="item.maxInput"
                                        label="Max Input"
                                        type="number"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row>
                                    <v-select
                                        class="width-250 mx-2"
                                        v-model="item.distributionName"
                                        label="Distribution"
                                        :items="
                                            distributions.map((d) => d.week)
                                        "
                                    ></v-select>
                                    <v-text-field
                                        class="width-200 mx-2"
                                        v-model="item.sort"
                                        label="Sort Order"
                                        type="number"
                                    ></v-text-field>
                                    <v-text-field
                                        class="width-200 mx-2"
                                        v-model="item.labelSort"
                                        label="Label Sort"
                                        type="number"
                                    ></v-text-field>
                                </v-layout>
                            </v-layout>
                            <div
                                v-if="
                                    item.editing && item.choiceType == 'CHOOSE'
                                "
                            >
                                <v-btn
                                    small
                                    color="success"
                                    class="ml-2 mt-0"
                                    @click="addChoice(item)"
                                    >Add Choice</v-btn
                                >
                                <v-layout
                                    row
                                    class="pa-0 ml-3 mb-0"
                                    v-for="(choice,
                                    choiceIndex) in item.choices"
                                >
                                    <v-text-field
                                        class="width-300 mr-2"
                                        v-model="choice.choice"
                                        label="Choice"
                                    ></v-text-field>
                                    <v-text-field
                                        class="width-100"
                                        v-model="choice.ivrInput"
                                        label="IVR Input"
                                        type="number"
                                        min="1"
                                    ></v-text-field>
                                    <v-btn
                                        @click="addChoice(item)"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        @click="removeChoice(item, choiceIndex)"
                                        flat
                                        icon
                                        color="#f55a4e"
                                    >
                                        <v-icon
                                            >mdi-minus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </v-layout>
                            </div>
                            <v-layout row class="mb-3 ml-2" v-if="item.editing">
                                <v-btn
                                    small
                                    class="mr-2"
                                    color="default"
                                    dark
                                    style="height: 28px;"
                                    @click="rollbackItem(item)"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    small
                                    color="success"
                                    style="height: 28px;"
                                    @click="saveMenuItem(item)"
                                    >Save</v-btn
                                >
                            </v-layout>
                            <v-divider
                                class="pb-0 pt-3"
                                v-if="index + 1 < menuItems.length"
                            ></v-divider>
                        </div>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import moment from "moment";
import { onlyUnique } from "../../utils/helpers.js";

export default {
    data: () => ({
        processing: false,
        menuItems: [],
        choices: [],
        newItems: [],
        distributions: [],
        isExporting: false,

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        rules: {
            required: (value) => !!value || "Required",
        },
    }),
    async created() {
        this.loadMenuItems();
        this.loadDistributions();
    },
    computed: {},
    methods: {
        async loadDistributions() {
            const response = await this.$http.get(
                "api/campDistribution/getDistributions",
            );

            this.distributions = response;
            this.distributions.push({ week: "ALL" });
        },
        async loadMenuItems() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuItems",
            );

            await this.loadMenuItemsChoices();

            this.menuItems = response.map((item) => {
                item.selected = false;
                item.editing = false;
                item.choices = this.choices.filter(
                    (c) => c.menuItemID == item.id,
                );
                item.choicesDisplay = item.choices.length
                    ? item.choices.map((c) => c.choice).join(",")
                    : "";
                item.distributionName = item.distributionID
                    ? this.getDistributionName(item.distributionID)
                    : "ALL";

                return item;
            });
        },
        async loadMenuItemsChoices() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuItemsChoices",
            );

            this.choices = response;
        },
        editItem(item) {
            item.editing = true;
        },
        rollbackItem(item) {
            item.editing = false;

            this.loadMenuItems();
        },
        addChoice(item) {
            console.log(item);
            item.choices.push({
                menuItemID: item.id,
                ivrInput: "",
                choice: "",
            });
        },
        removeChoice(item, index) {
            item.choices.splice(index, 1);
        },
        cancelNewItems() {
            this.newItems = [];
        },
        getDistributionName(id) {
            const distribution = this.distributions.find((d) => d.id == id);

            return distribution ? distribution.week : undefined;
        },
        getDistributionID(name) {
            if (!name) return null;

            return this.distributions.find((d) => d.week == name).id;
        },
        async saveMenuItem(menuItem, isNew = false) {
            if (isNew) {
                if (
                    !this.$refs.newName[0].validate(true) ||
                    !this.$refs.newDistributionType[0].validate(true)
                )
                    return;
            } else {
                const itemsEditing = this.menuItems.filter((i) => i.editing);
                const index = itemsEditing.indexOf(menuItem);

                if (
                    !this.$refs.name[index].validate(true) ||
                    !this.$refs.distributionType[index].validate(true)
                )
                    return;
            }

            menuItem.distributionID = this.getDistributionID(
                menuItem.distributionName,
            );

            try {
                this.processing = true;

                const data = {
                    item: menuItem,
                    choices: menuItem.choices,
                };

                await this.$http.post(
                    "api/campDistribution/saveMenuItem",
                    data,
                );

                this.processing = false;

                if (isNew) {
                    this.newItems = [];
                }

                this.loadMenuItems();
            } catch (e) {
                this.processing = false;
            }
        },
        addItem() {
            this.newItems.push({
                name: "",
                choiceType: "",
                allowChange: "",
                standard: "",
                distributionType: "SHABBOS",
                maxInput: "",
                sort: "",
                choices: [],
                distributionName: "ALL",
                distributionID: null,
                labelSort: "",
                itemDescription: "",
            });
        },
        async deleteItems() {
            try {
                this.processing = true;

                const items = this.menuItems.filter((i) => i.selected);

                await this.$http.post(
                    "api/campDistribution/deleteItems",
                    items,
                );

                this.processing = false;

                this.loadMenuItems();
            } catch (e) {
                this.processing = false;
            }
        },
        getExportFileName() {
            return "Menu Items - " + moment().format("L");
        },
        exportFields() {
            if (!this.menuItems.length) return;

            let fields = {};

            Object.keys(this.menuItems[0]).forEach((key) => {
                fields[key] = key;
            });

            return fields;
        },

        async exportToExcel() {
            return this.menuItems;
        },
    },
};
</script>
